/**
 * Minimal class-name joiner. Filters falsy values; later args override only
 * when caller explicitly orders them. Suficiente para os wrappers MARK V em
 * src/components/compass/ — sem necessidade de clsx/tailwind-merge nesse PR.
 */
export type ClassValue = string | number | false | null | undefined

export function cn(...classes: ClassValue[]): string {
  return classes.filter(Boolean).join(" ")
}
